gsap.registerPlugin(Draggable, InertiaPlugin);

document.addEventListener("DOMContentLoaded", function () {
    gsap.set('.co-os-s8-frame .z-ani-o', { opacity: 0, y: 40 });
    let cOsS8Tl1 = gsap.timeline({ paused: true });
    cOsS8Tl1.to('.co-os-s8-frame .z-ani-o', {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-os-s8-frame .z-ani-o',
        start: "40% bottom",
        end: "bottom top",
        animation: cOsS8Tl1
    });

    Draggable.create('.co-os-s8-image', {
        type: "x,y",
        edgeResistance: 0.65,
        bounds: ".co-os-s8-board",
        inertia: true,
        onDrag: function (self) {
            console.log(self.srcElement);
            self.srcElement.classList.add('current');
            // $('#cobalt-cursor-id').removeClass('co-mouseover-about-mood');
            // $('#cobalt-cursor-id .cobalt-cursor-child').css('opacity', '0');
        },
        onDragEnd: function (self) {
            self.srcElement.classList.remove('current');
            // $('#cobalt-cursor-id .cobalt-cursor-child').css('opacity', '1');
        },
    });
});